const Footer = () => {
    return (
        <footer className="footer">
            <div className="content has-text-centered">
                <p>
                    <b className='has-text-primary'>React Admin App</b> by <a href="https://github.com/ZakiMohammed" target='_blank' rel='noreferrer'>Zaki Mohammed</a>.
                </p>
            </div>
        </footer>
    )
}

export default Footer
